import FieldConfig from "../../../proto/field-config"
import FieldTotal from "../total/total"
import FieldAttachmentsTotal_TableCell from "./render/table/table-cell"
import FieldAttachmentsTotal_TableCellCalculated from "./render/table/calculated/table-cell-calculated"

export default class FieldAttachmentsTotal extends FieldTotal {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel                              = "Attachments"
        this.typeDescription                        = "Attachments"
        this.icon                                   = 'i5-attachment'

        this.renderComponents.tableCell             = FieldAttachmentsTotal_TableCell
        this.renderComponents.tableCellCalculated   = FieldAttachmentsTotal_TableCellCalculated
    }
}
